import { HomePageState, MenuItem } from "model/home";
import initialState from "store/state";
import { HomeActions } from "./action";
import {
  HOME_CLEAR_MAINMENU_ACTIVE,
  HOME_SET_MAINMENU_ACTIVE,
  HOME_SET_SUBMENU_OPENED,
} from "./constant";

export default function homeReducer(
  state = {} as HomePageState,
  action: HomeActions
) {
  const init = JSON.parse(JSON.stringify(initialState.home)) as HomePageState;
  const mainMenuList = JSON.parse(
    JSON.stringify(state.mainMenuList || [])
  ) as MenuItem[];

  switch (action.type) {
    case HOME_SET_MAINMENU_ACTIVE:
      mainMenuList.map((item) => {
        if (item.id === action.data.id) {
          item.active = !item.active;
        } else {
          item.active = false;
        }

        return item;
      });

      return {
        ...state,
        mainMenuList,
      };
    case HOME_CLEAR_MAINMENU_ACTIVE:
      return {
        ...state,
        mainMenuList: init.mainMenuList,
      };
    case HOME_SET_SUBMENU_OPENED:
      return {
        ...state,
        subMenuOpened: action.data.opened,
      };
    default:
      return state;
  }
}
